import React from 'react';

import IMG_1 from '../../../Images/gallery/unifin/img_1.png';
import IMG_2 from '../../../Images/gallery/unifin/img_2.png';
import IMG_3 from '../../../Images/gallery/unifin/img_3.png';
import IMG_4 from '../../../Images/gallery/unifin/img_4.png';
import IMG_5 from '../../../Images/gallery/unifin/img_5.png';
import IMG_6 from '../../../Images/gallery/unifin/img_6.png';

export const Unifin_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>UNIFIN</span>,
  },
];

export const Title_1 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>EMPRESARIO HECHO EN MÉXICO</span>,
  },
];

export const Title_2 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FOTO FIJA</span>,
  },
];

export const Unifin_Gallery = [
  {
    src: IMG_1,
    imgWidth: '100%',
  },
  {
    src: IMG_2,
    imgWidth: '50%',
  },
  {
    src: IMG_3,
    imgWidth: '50%',
  },
  {
    src: IMG_4,
    imgWidth: '50%',
  },
  {
    src: IMG_5,
    imgWidth: '50%',
  },
  {
    src: IMG_6,
    imgWidth: '100%',
  },
];
